import React, { Component, PropTypes } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Project from '../components/Project';

import { connect } from 'react-redux';
const { Link } = require('react-router')
//Change Class per Project
class MobileReddit extends React.Component {
  render () {
    const { projects, benchmark, personalInfo } = this.props;  
    console.log(personalInfo);
    
    const featProject = projects[1];

    // const params = this.props.params || {}
    // const { title, description, year, poster, trailer } = params
    return (
      <div className='container'>
        <Header personalInfo={personalInfo} />
        <div className=''>
          <div className='back-button'>
          <Link to='/'>
          <span className="glyphicon glyphicon-chevron-left"></span>
            Back to projects
          </Link>
          </div>
         

          <Project project={featProject}/>



        </div>

        <div className='case-study col-md-12 col-xs-12'>
        <h4>Mobile Reddit Swipe Client</h4>


<p>
I got this idea after using the Reddit Enhancement Suite function “view images”.  This loads all the images to the page for a given subreddit page.
</p>


<p>
I wondered if image related subreddits would be better consumed in a swipe card format for mobile users.  This is as much of a UI experiment as it is a great opportunity to dive into React Native for creating mobile apps.
</p>
<p>
In its simplest form the app would connect to the Reddit API, get hot 50 items for a single subreddit, find & fix the direct link to each image from various hosts (reddit, imgur, gyfcat), and load each image in a swipe card format.
</p>


<h4>
Working with react-native
</h4>


<p>
First thing I had to do was enable a terminal window with the console.  No point in shooting the dark since the iOS xcode viewer’s error messages are cryptic at best.
</p>


<pre>{`
$ react-native log-ios
$ react-native log-android
`}</pre> 


<h4>
Dirty Image Scraping
</h4>


<p>
One of the biggest issues encountered is that the JSON file that the Reddit API servers deliver does not always serve the correct direct links needed for embedding in: <p>{'<img src=’uri:(image link)’/>.'}</p>  



</p>


<p>
In fact using the given reddit direct image url: from the {'JSON'} file only correctly displayed 2 out of 25 images.
There needs to be some type of logic for resolving the broken links.
</p>


<pre>{`
fetch("https://www.reddit.com//r/aww/.json?sort=hot&limit=50", {method: "GET"})
  .then((response) => response.json())
  .then((responseData) => {
    responseData.data.children.forEach(function(picture)
 {
//The URL served by Reddits API 
        var url = picture.data.url;
`}</pre>


<p>
I checked out the RES open source code and realized how involved their image parsing algorithms were.  Luckily I was able to dig around and find some hacky ways to get images from different hosts to display correctly.
</p>


<p>
Imgur will usually work aka serve the direct link if you replace the file type with jpg, even for GIF’s.
</p>


<pre>{`
if (url_parsed.search("imgur") >= 0) {url_parsed = url_parsed + ".jpg";}
`}</pre>


<p>
For Reddit uploads I was able to use .png
</p>


<pre>{`
 if (url_parsed.search("reddituploads") >= 0) {url_parsed = url_parsed + ".png";}
`}</pre> 


<h4>
Working with IOS security and React Native
</h4>


<p>
Apple only allows https request and data transfers from native apps on the iphone.  There is a way to disable this for testing by editing the APP_Transport settings but a safer way was to fix each image link individually using a Javascript Regular Expression.
</p>
<pre>{`
url_parsed = url.replace(/^http:\/\//i, 'https://');
`}</pre> 
<p>
Full API connect - counter is a global variable used as an index and starts at 3 since the first cards are loaded from a separate dummy array.
</p>


<pre>{`
fetch("https://www.reddit.com//r/aww/.json?sort=hot&limit=20", {method: "GET"})
  .then((response) => response.json())
  .then((responseData) => {
    responseData.data.children.forEach(function(picture)
      {
        // data.url is the image link from reddit, you could also get like data.title etc.
        var url = picture.data.url;
        

        //iOS Fix (RegEx)
        url_parsed = url.replace(/^http:\/\//i, 'https://');

        counter = counter + 1

        //Reddit Fix
        if (url_parsed.search("reddituploads") >= 0) {url_parsed = url_parsed + ".png";}

        //Imgur Fix
        var url_parsed = url.replace(".gifv",".jpg");
        if (url_parsed.search("imgur") >= 0) {url_parsed = url_parsed + ".jpg";}

        // console.log(picture.data.url);
        var tempdata = {'name': counter ,'image': url_parsed}
        
        //console.log(tempdata);
        Cards2.push(tempdata);


      })
  
  })
  .done();  
  
`}</pre> 
        </div>
        <Footer personalInfo={personalInfo} />
      </div>
    )
  }
}

const { object, array } = React.PropTypes

MobileReddit.propTypes = {
  projects: PropTypes.array.isRequired,
  personalInfo: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    projects: state.projects,
    personalInfo: state.personalInfo
  };
}

//Change for each project

export default connect(mapStateToProps)(MobileReddit)




/** WEBPACK FOOTER **
 ** ./src/pages/MobileReddit.js
 **/